<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 56 70"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.5502041,17.2518367 L39.5502041,1.94877551 L52.2818367,17.2518367 L39.5502041,17.2518367 Z M41.2844898,0.641632653 C40.8604082,0.216122449 40.4659184,0.00551020408 40.1393878,0 L10,0 C4.4771525,1.01453063e-15 -6.17072177e-13,4.4771525 -6.14619466e-13,10 L-6.14619466e-13,62.4595918 L-6.14619466e-13,62.4595918 C-6.14619466e-13,66.3881633 3.21428571,69.602449 7.14285714,69.602449 L48.8079592,69.602449 C52.7365306,69.602449 55.9508163,66.3881633 55.9508163,62.4595918 L55.9508163,19.2314286 C55.9436735,18.9065306 55.7259184,18.5130612 55.3018367,18.0889796 L41.2844898,0.641632653 Z"
      :fill="fill"
    ></path>
		<text dx="8" dy="16">{{type}}</text>
  </svg>
</template>

<script>
export default {
  props: {
		type: {
			type: String,
			ddefault: ''
		},
    width: {
      type: Number,
      default: 56,
    },
    height: {
      type: Number,
      default: 70,
    },
    fill: {
      type: String,
      default: "#FF3D37",
    },
  },
};
</script>

<style scoped>
svg text {
	font-size: 10px !important;
	text-transform: uppercase;
	font-weight: 500 !important;
	color: #fff;
	fill: #fff;
}
</style>
